module.exports = __webpack_public_path__ + "static/build_typo_2-867c57ed258c28a669d85cda155f05d3.png";